export const splitOrgNr = (orgNr: string): string =>
    `${orgNr.substr(0, 3)}  ${orgNr.substr(3, 3)}  ${orgNr.substr(6, 3)}`;

export const splitNumber = (number: string): string =>
    number.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
